namespace TabAurous.Retail {
    export interface AuthorizeForm {
        Username: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        Remark: Serenity.StringEditor;
    }

    export class AuthorizeForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.Authorize';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AuthorizeForm.init)  {
                AuthorizeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.PasswordEditor;

                Q.initFormType(AuthorizeForm, [
                    'Username', w0,
                    'Password', w1,
                    'Remark', w0
                ]);
            }
        }
    }
}
